<template>
    <div class="dob-container">
        <CustomDatePicker @cancel="closeModal" @apply="updateDob($event)" :isApplying="isUpdatingDob" :initial-date="dob" :minAge="18"  />
    </div>
</template>

<script setup lang="ts">
import CustomDatePicker from '~/components/main/shared/CustomDatePicker.vue';
import { ModalNames } from '~/types/modals';

const personStore = usePersonStore();
// Parse DOB as local time by adding T12:00:00 to avoid timezone shift issues
// Date-only strings like "1988-04-26" are parsed as UTC midnight, which can shift back one day in western timezones
const dob = ref<Date | undefined>(personStore.person?.dob ? new Date(personStore.person?.dob + 'T12:00:00') : undefined);

const isUpdatingDob = ref(false);

const updateDob = async (value: Date) => {
    isUpdatingDob.value = true;
    // Create a new date with the same year, month, and day but at noon to avoid timezone issues
    const dateAtNoon = new Date(value.getFullYear(), value.getMonth(), value.getDate(), 12, 0, 0);
    const updatePayload: any = {
        first_name: personStore.person?.first_name,
        dob: dateAtNoon.toISOString(),
    };
    // Only include middle_name if it's a non-empty string (null/undefined/empty should not be sent)
    if (personStore.person?.middle_name) {
        updatePayload.middle_name = personStore.person.middle_name;
    }
    // Only include last_name if it's a non-empty string
    if (personStore.person?.last_name) {
        updatePayload.last_name = personStore.person.last_name;
    }
    await personStore.updatePerson(updatePayload);
    isUpdatingDob.value = false;
    closeModal();
};

const dialogRef = getDialogRef(ModalNames.EDIT_DOB);

const closeModal = () => {
    dialogRef.value.close();
};
</script>

<style scoped lang="scss">
.dob-container {
    @apply rounded-md sm:p-6 p-0 flex flex-col gap-6;
}
</style>
